{
  "title": "받은 편지함",
  "totalBadge": "{{count}}개",
  "viewAll": "모두 보기",
  "loading": "로드 중…",
  "emptySection": "모두 처리됨",
  "loadError": "이 섹션을 로드할 수 없습니다"
}
